// @flow
import type { Country } from '../country';
import { COLOMBIA_COUNTRY_CODE } from '@tectonics/prs/colombia/constants';

export function normalizeColombianPhoneNumber(phoneNumber: ?string): string {
  if (!phoneNumber) {
    return '';
  }

  const cleaned = phoneNumber.replace(/\D/g, '');

  if (cleaned.startsWith(COLOMBIA_COUNTRY_CODE) && cleaned.length > 10) {
    return cleaned.substring(COLOMBIA_COUNTRY_CODE.length);
  }

  return cleaned;
}

const COLOMBIA: Country = {
  code: 'co',
  customerForm: {
    phoneNumber: {
      normalizer: normalizeColombianPhoneNumber,
    },
  },
};

export default COLOMBIA;
